export default __webpack_public_path__ + "static/media/mm.8630dbe0.jpg";